import React, { useEffect, useRef } from 'react';
export interface FieldError {
  /** The id of the field this problem belongs to. */
  fieldId: string;
  message: string;
}
interface ErrorSummaryProps {
  errors: FieldError[];
  /** Rendered as the summary heading. */
  title?: string;
}

/**
 * Lists every problem, links each to its field, and takes focus on failed
 * submit so a screen reader user is told what went wrong rather than being
 * left at a submit button that did nothing.
 */
export function ErrorSummary({
  errors,
  title = 'There is a problem'
}: ErrorSummaryProps) {
  const ref = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (errors.length > 0) {
      ref.current?.focus();
    }
  }, [errors]);
  if (errors.length === 0) return null;
  return <div data-component-id="C07" ref={ref} role="alert" tabIndex={-1} className="rounded-container border-2 border-rust bg-rust/5 p-4 focus:outline-none focus:ring-2 focus:ring-rust/50" data-id="element-421" data-mp="3l880ullexmdp">
      <h3 className="flex items-center gap-2 text-sm font-bold uppercase tracking-[0.12em] text-rust" data-id="element-422" data-mp="2n4i94wyfxsjp">
        <span aria-hidden="true" data-id="element-423" data-mp="2idib1odl54fm">▲</span>
        {title}
      </h3>
      <ul className="mt-2 space-y-1" data-id="element-424" data-mp="2ic76vng89unz">
        {errors.map(error => <li key={error.fieldId} data-id="element-425" data-mp="2dfgq0xwlmv1i">
            <a href={`#${error.fieldId}`} onClick={event => {
          event.preventDefault();
          const field = document.getElementById(error.fieldId);
          field?.focus();
          field?.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
          });
        }} className="text-sm font-medium text-rust underline decoration-rust/40 underline-offset-2 hover:decoration-rust focus:outline-none focus:ring-2 focus:ring-rust/50" data-id="element-426" data-mp="28fvteu4wiyry">
              {error.message}
            </a>
          </li>)}
      </ul>
    </div>;
}